import { create } from 'zustand';

export interface IGroupedSelect {
  itemHovered?: string;
  setItemHovered: (itemHovered?: string) => void;
}

export const useGroupedSelect = create<IGroupedSelect>()((set) => ({
  itemHovered: undefined,
  setItemHovered: (itemHovered) => set({ itemHovered }),
}));
